<template>
<div class="chapter">
<div class="inner_page">
<div id="AsXT">
<h1 class="h1a" id="pz9-1" style="margin-bottom: 3.7em; margin-top: 5.7em;">
<a href="#/loi#d1">Acknowledgments</a> </h1>
<p class="indent" id="pz9-2" style="text-indent: 0">
					This book originated at the InterGenerate Conference held at Lipscomb University
					in Nashville, Tennessee, in June 2017. So, my gratitude goes to those who made both
					the conference and the book a reality. </p>
<p class="indent" id="pz9-3">
					The InterGenerate Task Force, listed below, wishes to express its profound appreciation
					to both GenOn Ministries<sup><a href="#/#pz11-11a" id="bl84a">1</a></sup> and Lipscomb University<sup><a href="#/#pz11-11" id="bl84">2</a></sup> who sponsored the conference.
					</p>
<p class="indent" id="pz9-4">
					GenOn Ministries bathed InterGenerate in prayer, provided initial funding for website
					expenses, and offered regular promotional support. In addition, at the very beginning,
					Liz Perraud, executive director of GenOn, created a survey, which she sent to around
					one hundred people we knew to be interested in intergenerational ministry, to discern
					the level of interest for an intergenerational conference; the strong, positive response
					provided the impetus to carry the conference vision forward. Several survey respondents
					became part of the task force, along with Shirley Carlson (GenOn board member) and
					Suzie Lane (GenOn program director). </p>
<p class="indent" id="pz9-5">
					Generous upfront support from Lipscomb University enabled the InterGenerate task
					force to begin their work. These funds were approved by Randy Lowry, president of
					Lipscomb University, and Danny Taylor, Lipscomb’s CFO. Lipscomb’s Hazelip School
					of Theology and the Institute for Christian Spirituality covered the costs of trademarking
					the word <span id="z10-6">“InterGenerate” and printing the program booklet along with other conference-related
					expenses. </span></p>
<p class="indent" id="pz10-7">
					A special thanks goes to Cory Seibel for his help in editing this text; he offered
					invaluable insight and suggestions for two of the chapters—besides the two chapters
					that he authored. </p>
<p class="indent" id="pz10-8">
					Also, we should acknowledge that two members of the task force, Melissa Cooper (a
					millennial) and Olivia Updegrove (a Gen Xer), created the name for the conference
					and for the book—<i>InterGenerate</i>; we are so glad our task force is <i>intergenerational</i>.
					</p>
<p class="indent" id="pz10-9">
					On a personal note, I wish to thank the women with whom I meet and pray on Tuesday
					evenings: Linda Blanks, Linda Bridgesmith, Mary Hemminger, Rebecca Lavender, and
					Kathy Musick. These women have tracked with <i>InterGenerate</i> from the beginning, catching
					an early glimpse of the vision, listening patiently along the way, holding up my
					hands when challenges surfaced, believing with me that this was God’s work, and sharing
					the joy as this work has come to completion. </p>
<p class="indentv" id="pz10-10">
					The following people formed the InterGenerate Task Force: </p>
<p class="indent" id="pz10-11">
<img alt="images/nec-10-1.png" id="ApQ" src="images/nec-10-1.png" style="vertical-align: middle"/> Ron DeVries, Vice-Chair </p>
<p class="indent" id="pz10-12" style="margin-left: 2.3em; text-indent: 0em;">
					Regional Catalyzer, Faith Formation Ministries, Alberta, Canada </p>
<p class="indent" id="pz10-13">
<img alt="images/nec-10-2.png" id="AM_K" src="images/nec-10-2.png" style="vertical-align: middle"/> John Roberto, Treasurer </p>
<p class="indent" id="pz10-14" style="margin-left: 2.3em; text-indent: 0em;">
					Vibrant Faith Leadership Team, Naugatuck, Connecticut </p>
<p class="indent" id="pz10-15">
<img alt="images/nec-10-3.png" id="AdL9" src="images/nec-10-3.png" style="vertical-align: middle"/> Karen DeBoer, Secretary </p>
<p class="indent" id="pz10-16" style="margin-left: 2.3em; text-indent: 0em;">
					Creative Resource Developer, Faith Formation Ministries, Kitchener, Ontario, Canada </p>
<p class="indent" id="pz10-18">
<img alt="images/nec-10-4.png" id="App8" src="images/nec-10-4.png" style="vertical-align: middle"/> Melissa Cooper, Website manager </p>
<p class="indent" id="pz10-19" style="margin-left: 2.3em; text-indent: 0em;">
					Associate, Vibrant Faith, Kissimmee, Florida </p>
<p class="indent" id="pz10-20">
<img alt="images/nec-10-5.png" id="AKu" src="images/nec-10-5.png" style="vertical-align: middle"/> Shirley Carlson </p>
<p class="indent" id="pz10-21" style="margin-left: 2.3em; text-indent: 0em;">
					GenOn Ministries board member, Port Clinton, Ohio </p>
<p class="indent" id="pz10-22">
<img alt="images/nec-10-6.png" id="AOhV" src="images/nec-10-6.png" style="vertical-align: middle"/> Darwin Glassford </p>
<p class="indent" id="pz10-23" style="margin-left: 2.3em; text-indent: 0em;">
					Executive Pastor at Harderwyk Ministries in Holland, MI; and Director of Graduate
					Programs and Online Learning at Kuyper College, Grand Rapids, Michigan </p>
<p class="indent" id="pz10-26">
<img alt="images/nec-10-7.png" id="AvZ" src="images/nec-10-7.png" style="vertical-align: middle"/> Suzie Lane </p>
<p class="indent" id="pz10-27" style="margin-left: 2.3em; text-indent: 0em;">
					Program Director, GenOn Ministries, Nashville, Tennessee </p>
<p class="indent" id="pz11-1">
<img alt="images/nec-11-1.png" id="ABjB" src="images/nec-11-1.png" style="vertical-align: middle"/> Linda Staats </p>
<p class="indent" id="pz11-2" style="margin-left: 2.3em; text-indent: 0em;">
					HomeGrown Faith, Phoenix, Arizona </p>
<p class="indent" id="pz11-3">
<img alt="images/nec-11-2.png" id="A3pt" src="images/nec-11-2.png" style="vertical-align: middle"/> Olivia Updegrove </p>
<p class="indentv" id="pz11-4" style="margin-left: 2.3em; text-indent: 0em;">
					Minister of Family and Children’s Ministries at Disciples Home Mission, Indianapolis,
					Indiana </p>
<p class="indentv" id="pz11-6" style="text-indent: 0">
					This hard-working, committed group of people stepped into the idea of convening an
					intergenerational conference from scratch with passion and panache. Together, we
					represent Christians from a number of traditions: Catholic, Churches of Christ, Christian
					Reformed, Disciples of Christ, Methodist, Lutheran, and Presbyterian. It has been
					one of the most delightful experiences of my life to envision and create something
					new with these remarkable people; a wonderful <i>esprit de corps</i> emerged over the eighteen
					months we worked together. Both the conference and this book reflect this amazing
					spirit, and we learned to say along the way, “To God be the glory.” </p>
<p class="indent" id="pz11-7" style="text-indent: 0">
					Holly Catterton Allen<br/>
					Chair, InterGenerate Task Force</p>
<h5 class="h5" id="AyaR">
<span id="AzV8" style="color: rgb(79,75,76);">Notes</span> </h5>
<div class="bibliography" id="AU9">
<p class="footnote" id="pz11-11a">
<sup><a href="#/#bl84a">1</a></sup><b>GenOn Ministries:</b> <a href="http://www.genonministries.org" id="AcFh" target="_blank">www.genonministries.org</a> GenOn Ministries equips faith communities
						for Christian discipleship and builds and nurtures relationships with God through
						Jesus Christ through intergenerational resources, trainings, conferences, and Youth
						Summits. </p>
<p class="footnote" id="pz11-11">
<sup><a href="#/#bl84" id="anchor_id_1">2</a></sup><b>Lipscomb University:</b> <a href="http://www.lipscomb.edu" id="Aqx" target="_blank">www.lipscomb.edu</a> Lipscomb University is a private Christian
						liberal arts university in Nashville, Tennessee, offering bachelors, masters, and
						doctoral degrees. Its primary mission is to integrate Christian faith and practice
						with academic excellence. This mission is carried out not only in the classroom but
						also by involvement in numerous services to the church and the larger community.
						(<a href="http://www.lipscomb.edu/about/mission" id="A2XA" target="_blank">www.lipscomb.edu/about/mission</a>) </p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?c8664350